import React, { useState, useEffect, useContext } from "react";
import { ContextBoard } from "../../context/ContextBoard";
import { useNavigate } from "react-router-dom";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import Swal from "sweetalert2";
import config from "../../config";
import * as XLSX from "xlsx";
import { AnimatePresence, motion } from "framer-motion";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function Dashboard11() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState({});
  const [showDistrictModal, setShowDistrictModal] = useState(false);
  const { setSelectedDistrict } = useContext(ContextBoard);
  const [districtList, setDistrictList] = useState([]);
  const [selectedCard, setSelectedCard] = useState("");
  const token = sessionStorage.getItem("intermediateaccountstoken");

  const fetchDashboardData = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/FODashboardPendingApproRjectCount_CL11_NEW`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      // console.log("Response:", data);
      if (response.ok) {
        setDashboardData(data.data.foDashboardCount_data || {});
      } else {
        Swal.fire("Error", data?.message || "Unable to fetch data", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong. Try again later.", "error");
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const handleCardClick = async (apiEndpoint) => {
    setLoading(true);
    try {
      const response = await fetch(`${config.API_BASE_URL}/${apiEndpoint}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      // console.log("Response:", data);
      if (response.ok) {
        if (data.data.distWiseCount_list.length === 0) {
          Swal.fire("Info", "No districts found for this report.", "info");
        } else {
          setDistrictList(data.data.distWiseCount_list || []);
          setShowDistrictModal(true);
        }
      } else {
        Swal.fire("Error", data?.message || "Unable to fetch data", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong. Try again later.", "error");
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDistrictSelect = (districtCode) => {
    const routes = {
      paymentPending: "/intermediate-accounts-payment-pending-class-xi",
      paymentApproved: "/intermediate-accounts-verified-payment-class-xi",
      paymentRejected: "/intermediate-accounts-reject-payment-class-xi",
      challanPending:
        "/intermediate-accounts-challan-pending-submission-class-xi",
      challanNotGenerated:
        "/intermediate-accounts-challan-not-generated-class-xi",
    };
    const route = routes[selectedCard];
    if (!route) {
      Swal.fire("Error", "Please select a valid card.", "error");
      return;
    }
    setSelectedDistrict(districtCode);
    navigate(route);
    setShowDistrictModal(false);
  };

  const reportOptionsClass11 = [
    {
      label: "All Challan Report",
      url: `${config.API_BASE_URL}/AdminGetAllChallanReportIntermediate`,
      method: "GET",
      datacount: dashboardData.alL_CHALLAN_REPORT || "",
      dataPath: `data["allChallanReport_list"]`,
      cardColor: "card card-light-warning",
    },

    {
      label: "Approved Payments",
      url: `${config.API_BASE_URL}/AdminGetFOApprovedReportIntermediate`,
      method: "GET",
      datacount: dashboardData.totaL_APPROVED_PAYMENTS || 0,
      dataPath: `data["approvedReport_list"]`,
      cardColor: "card card-tale",
    },
    {
      label: "Rejected Payments",
      url: `${config.API_BASE_URL}/AdminGetFORejectedReportIntermediate`,
      method: "GET",
      datacount: dashboardData.totaL_REJECT_PAYMENTS || 0,
      dataPath: `data["rejectedReport_list"]`,
      cardColor: "card card-danger",
    },
    {
      label: "Challan Not Generated",
      url: `${config.API_BASE_URL}/AdminChallanNotGenerateReportIntermediate`,
      method: "GET",
      datacount: dashboardData.challaN_NOT_GENERATED || "",
      dataPath: `data["adminChallanNotGenerateReport_list"]`,
      cardColor: "card card-light-grey",
    },
    {
      label: "Challan Pending for Submission",
      url: `${config.API_BASE_URL}/AdminFOChlnPendingForSubReportIntermediate`,
      method: "GET",
      datacount: dashboardData.challaN_PENDING_FOR_SUBMISSION || "",
      dataPath: `data["challanPendingForSubReport_list"]`,
      cardColor: "card card-orange",
    },
    {
      label: "Pending for Verification",
      url: `${config.API_BASE_URL}/AdminGetFOPendingReportIntermediate`,
      method: "GET",
      datacount: dashboardData.totaL_PAYMENT_PENDING_VERIFICATION || "",
      dataPath: `data["pendingReport_list"]`,
      cardColor: "card card-dark-blue",
    },
  ];

  const getValueFromPath = (obj, path) => {
    try {
      return path
        .replace(/\[(["']?)([^\[\]"']+)\1\]/g, ".$2")
        .replace(/^\./, "")
        .split(".")
        .reduce((acc, key) => acc?.[key], obj);
    } catch {
      return undefined;
    }
  };

  const fetchReportData = async (option) => {
    if (!token) {
      Swal.fire("Auth Error", "Token is missing. Please login.", "error");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(option.url, {
        method: option.method,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();
      const extractedData = getValueFromPath(result, option.dataPath) || [];

      if (!extractedData.length) {
        Swal.fire("No data found.", "", "info");
        return;
      }

      generateExcelReport(extractedData, option.label);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Error fetching report.", "error");
    } finally {
      setLoading(false);
    }
  };

  const generateExcelReport = (data, title) => {
    try {
      const formatHeader = (key) => key.toUpperCase();
      const headers = ["Sl. No.", ...Object.keys(data[0])];
      const formattedHeaders = [
        "SL. NO.",
        ...Object.keys(data[0]).map(formatHeader),
      ];

      const now = new Date();
      const dateStr = `${String(now.getDate()).padStart(2, "0")}-${String(
        now.getMonth() + 1
      ).padStart(2, "0")}-${now.getFullYear()}  ${now
        .toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        })
        .toUpperCase()}`;

      const ws = XLSX.utils.aoa_to_sheet([
        [`Report: ${title}`],
        [`Generated on: ${dateStr}`],
        [],
        formattedHeaders,
      ]);

      const rows = data.map((item, i) => [
        i + 1,
        ...headers.slice(1).map((key) => item[key] ?? ""),
      ]);
      XLSX.utils.sheet_add_aoa(ws, rows, { origin: -1 });

      ws["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: formattedHeaders.length - 1 } },
      ];
      ws["!cols"] = formattedHeaders.map(() => ({ wch: 20 }));

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Report");

      const safeFileName = `Report_Class11_${title.replace(
        /[^a-zA-Z0-9]/g,
        "_"
      )}.xlsx`;
      XLSX.writeFile(wb, safeFileName);

      Swal.fire("Success", "Excel file downloaded", "success");
    } catch (err) {
      console.error("Excel generation failed", err);
      Swal.fire("Error", "Failed to generate Excel", "error");
    }
  };

  return (
    <div className="container-scroller">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      <Navbar />
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-md-12 mb-3">
                <div className="row">
                  <div className="col-12 col-xl-12 mb-4 mb-xl-0">
                    <h3
                      className="font-weight-bold"
                      style={{ textTransform: "uppercase" }}
                    >
                      Welcome Accounts
                    </h3>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              {/* Total Payments - Pending for Verification */}
              <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                <div
                  className="card card-dark-blue"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleCardClick("FOPendingDistrictWiseCount_CL11");
                    setSelectedCard("paymentPending");
                  }}
                >
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-9">
                        <h3 className="mb-2">Pending for Verification</h3>
                        <p className="fs-30 mb-2 mt-4">
                          {dashboardData.totaL_PAYMENT_PENDING_VERIFICATION ||
                            0}
                        </p>
                      </div>
                      <div className="col-md-3" style={{ textAlign: "center" }}>
                        <i
                          className="fa fa-clock-o icon-large"
                          style={{ fontSize: 40 }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Total Approved Payments */}
              <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                <div
                  className="card card-success"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    /* navigate("/secondary-accounts-verified-payment") */
                    handleCardClick("FOApprovedDistrictWiseCount_CL11");
                    setSelectedCard("paymentApproved");
                  }}
                >
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-9">
                        <h3 className="mb-2">Total Approved Payments</h3>
                        <p className="fs-30 mb-2 mt-4">
                          {dashboardData.totaL_APPROVED_PAYMENTS || 0}
                        </p>
                      </div>
                      <div className="col-md-3" style={{ textAlign: "center" }}>
                        <i
                          className="fa fa-check icon-large"
                          style={{ fontSize: 40 }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Total Rejected Payments */}
              <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                <div
                  className="card card-light-danger"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    /* navigate("/secondary-accounts-reject-payment") */
                    handleCardClick("FORejectedDistrictWiseCount_CL11");
                    setSelectedCard("paymentRejected");
                  }}
                >
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-9">
                        <h3 className="mb-2">Total Rejected Payment</h3>
                        <p className="fs-30 mb-2 mt-4">
                          {dashboardData.totaL_REJECT_PAYMENTS || 0}
                        </p>
                      </div>
                      <div className="col-md-3" style={{ textAlign: "center" }}>
                        <i
                          className="fa fa-times icon-large"
                          style={{ fontSize: 40 }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Challan Pending for FO Submission */}
              <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                <div
                  className="card card-dark-danger"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    /* navigate("/secondary-accounts-challan-pending-submission") */
                    handleCardClick(
                      "FOChallanPendingForSubmissionDistWiseCount_CL11"
                    );
                    setSelectedCard("challanPending");
                  }}
                >
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-9">
                        <h3 className="mb-2">
                          Challan Pending for FO Submission
                        </h3>
                        <p className="fs-30 mb-2 mt-4">
                          {dashboardData.challaN_PENDING_FOR_SUBMISSION || 0}
                        </p>
                      </div>
                      <div className="col-md-3" style={{ textAlign: "center" }}>
                        <i
                          className="fa fa-clipboard icon-large"
                          style={{ fontSize: 40 }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Challan Not Generated */}
              <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                <div
                  className="card card-light-warning"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    /* navigate("/secondary-accounts-challan-pending-submission") */
                    handleCardClick(
                      "FOChallanNotGeneratedDistrictWiseCount_CL11"
                    );
                    setSelectedCard("challanNotGenerated");
                  }}
                ></div>
              </div>
            </div>

            <div className="row">
              {reportOptionsClass11.map((option) => (
                <div
                  key={option.label}
                  className="col-md-3 col-xl-3 mb-4 stretch-card transparent"
                >
                  <div
                    className={option.cardColor}
                    style={{ cursor: "pointer" }}
                    onClick={() => fetchReportData(option)}
                  >
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-9">
                          <h3 className="mb-2">{option.label}</h3>
                          <p className="fs-30 mb-2 mt-4">{option.datacount}</p>
                        </div>
                        <div
                          className="col-md-3"
                          style={{ textAlign: "center" }}
                        >
                          <i
                            className="fa fa-download icon-large"
                            style={{ fontSize: 40 }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <Footer />
        </div>
      </div>
      <AnimatePresence>
        {showDistrictModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              backdropFilter: "blur(8px)",
              WebkitBackdropFilter: "blur(8px)",
              zIndex: 1100,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3 }}
              style={{
                width: "95%",
                maxWidth: "600px",
                borderRadius: "12px",
                background: "#fff",
                overflow: "hidden",
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: "10px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "stretch",
                }}
              >
                {/* <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <button
                    type="button"
                    className="btn close"
                    aria-label="Close"
                    onClick={handleDistrictModalClose}
                  >
                    <i className="fa fa-times"></i>
                  </button>
                </div> */}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <h5 className="modal-title" style={{ margin: 0 }}>
                    {{
                      paymentPending: "Pending for Verification",
                      paymentApproved: "Total Approved Payments",
                      paymentRejected: "Total Rejected Payments",
                      challanPending: "Challan Pending for FO Submission",
                      challanNotGenerated: "Challan Not Generated",
                    }[selectedCard] || ""}
                  </h5>

                  {/* <button
                    className="btn btn-success btn-sm"
                    onClick={() => fetchReportData(selectedCard)}
                  >
                    <i className="fa fa-file-excel-o"></i> Export Excel
                  </button> */}
                </div>
              </div>

              <div
                className="modal-body"
                style={{
                  padding: "10px",
                  border: "1px solid lightgray",
                  maxHeight: "80vh",
                  overflowY: "auto",
                }}
              >
                <table className="table table-bordered table-striped table-hover">
                  <thead>
                    <tr>
                      <th>District Name</th>
                      <th>Challan Count</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {districtList.map((district, index) => {
                      /* const valueMap = {
                        paymentPending: district.totaL_DEO_PENDING_COUNT,
                        paymentApproved: district.totaL_DEO_APPROVED_COUNT,
                        paymentRejected: district.totaL_DEO_REJECTED_COUNT,
                        challanPending: district.challaN_PENDING_FOR_SUBMISSION,
                        challanNotGenerated: district.challaN_NOT_GENERATED,
                      }; */

                      return (
                        <tr key={district.districT_CODE || index}>
                          <td>{district.districT_NAME}</td>
                          <td className="text-end">
                            {district.challan_count || 0}
                          </td>
                          <td className="text-center">
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() =>
                                handleDistrictSelect(district.districT_CODE)
                              }
                            >
                              <i className="fa fa-check-circle"></i> Select
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <div
                className="modal-footer"
                style={{ padding: "10px", display: "flex", gap: "5px" }}
              >
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={() => setShowDistrictModal(false)}
                >
                  <i className="fa fa-times"></i> Close
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default Dashboard11;
